import { Box, Grid, Typography } from "@mui/material";
import { MainContainer } from "../../components/MainContainerComp";
import { messageStyle } from "./styled";

interface IEmailVerificationProps {
  success: boolean;
}

export const EmailVerification: React.FC<IEmailVerificationProps> = ({ success }) => {
  const title = success ?
    "Email is Verified" :
    "Verification Link Has Expired";

  return (
    <MainContainer title={title}>
      <Grid container sx={{ justifyContent: 'center' }} spacing={2}>
        <Grid item md={6} xs={12}>
          <Box sx={messageStyle}>
            {success ?
              <>
                <Typography>
                  <Box sx={{ fontWeight: 'bold', display: 'inline-flex' }}>Your email address has been updated.</Box> Feel free to close this window.
                </Typography>
              </> :
              <>
                <Typography>
                  Your verification link is expired. Please update your email in your User Profile.
                </Typography>
                <Typography sx={{ mt: 3 }}>
                  Feel free to close this window.
                </Typography>
              </>
            }
          </Box>
        </Grid>
      </Grid>
    </MainContainer>
  )
}

